import React, { Component } from "react"
import { withStyles } from "@material-ui/core"
import * as constants from "../constants"
import { Cookies } from "react-cookie"
import Grid from "@material-ui/core/Grid"
import Divider from "@material-ui/core/Divider"
import FloatingLabelInput from "./FloatingLabelInput"
import Select from "react-select"
import Button from "@material-ui/core/Button"
import Fab from "@material-ui/core/Fab"
import EditIcon from "@material-ui/icons/Edit"
import DeleteIcon from "@material-ui/icons/Delete"
import Snackbar from "@material-ui/core/Snackbar"
import { Alert, AlertTitle } from "@material-ui/lab"

const styles = (theme) => ({
      button: {
            margin: theme.spacing.unit,
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ResbuildmngBuildinglife extends Component {
      cookies = new Cookies()
      constructor(props) {
            super(props)

            this.state = {
                  resbuildmngBuildinglifeState: this.props.resbuildmngBuildinglife,
                  selectedResbuildmngBuildinglife: {
                        value: this.props.resbuildmngBuildinglife.resbuildmng_price_buildinglife_resbuildmng_buildinglife_id,
                        label: this.props.resbuildmngBuildinglife.resbuildmng_buildinglife_name,
                  },
                  visible: true,
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  optionResbuildmngBuildinglife: [],
            }
      }
      componentDidMount() {
            this.getoptionResbuildmngBuildinglife()
      }

      getoptionResbuildmngBuildinglife = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].resbuildmng_buildinglife_id, label: arr.data[k].resbuildmng_buildinglife_name })
                              }
                              self.setState({ optionResbuildmngBuildinglife: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_resbuildmng_buildinglife")
            xhttp.open("POST", `${constants.BASE_URL}/resbuildmng`)
            xhttp.send(fd)
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleInstalmentMode = (selectedResbuildmngBuildinglife) => {
            var temparray = this.state.resbuildmngBuildinglifeState
            temparray.resbuildmng_price_buildinglife_resbuildmng_buildinglife_id = selectedResbuildmngBuildinglife.value
            this.setState({ selectedResbuildmngBuildinglife: selectedResbuildmngBuildinglife, resbuildmngBuildinglifeState: temparray })
      }

      handleChangeConditionsPercent = (event) => {
            var temparray = this.state.resbuildmngBuildinglifeState
            temparray.resbuildmng_price_buildinglife_percent = event
            this.setState({ resbuildmngBuildinglifeState: temparray })
      }

      modifyNewInstalmentCondition = () => {
            const { resbuildmngBuildinglifeState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "modify_price_buildinglife")
            fd.append("resbuildmng_price_buildinglife_id", resbuildmngBuildinglifeState.resbuildmng_price_buildinglife_id)
            fd.append("resbuildmng_price_buildinglife_percent", resbuildmngBuildinglifeState.resbuildmng_price_buildinglife_percent)

            xhttp.open("POST", `${constants.BASE_URL}/resbuildmng`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      deleteInstalmentCondition = () => {
            const { resbuildmngBuildinglifeState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ visible: false, snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_price_buildinglife")
            fd.append("resbuildmng_price_buildinglife_id", resbuildmngBuildinglifeState.resbuildmng_price_buildinglife_id)

            xhttp.open("POST", `${constants.BASE_URL}/resbuildmng`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      render() {
            const { classes } = this.props
            const {
                  optionResbuildmngBuildinglife,
                  snackMode,
                  snackstr,
                  showSnack,
                  visible,
                  selectedResbuildmngBuildinglife,
                  resbuildmngBuildinglifeState,
            } = this.state
            if (visible) {
                  return (
                        <Grid container spacing={3}>
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>

                              <Grid item xs={5}>
                                    <div>
                                          <label className="on"> عمر بنا</label>
                                          <Select
                                                isSearchable={true}
                                                className="adapter-txtsize"
                                                placeholder={"عمر بنا"}
                                                value={selectedResbuildmngBuildinglife}
                                                onChange={this.handleInstalmentMode}
                                                options={optionResbuildmngBuildinglife}
                                          />
                                    </div>
                              </Grid>

                              <Grid item xs={4}>
                                    <FloatingLabelInput
                                          placeholder="درصد عمر بنا "
                                          type="percent"
                                          handleInputt={this.handleChangeConditionsPercent}
                                          value={resbuildmngBuildinglifeState.resbuildmng_price_buildinglife_percent}
                                    />
                              </Grid>

                              <Grid item xs={3}>
                                    <div style={{ width: "100%", textAlign: "left" }}>
                                          <Fab
                                                className={classes.small}
                                                style={{ background: "#44b700" }}
                                                aria-label="edit"
                                                onClick={this.modifyNewInstalmentCondition}
                                          >
                                                <EditIcon />
                                          </Fab>

                                          <Fab className={classes.small} color="secondary" aria-label="edit" onClick={this.deleteInstalmentCondition}>
                                                <DeleteIcon />
                                          </Fab>
                                    </div>
                              </Grid>
                              <Grid item xs={12}>
                                    <Divider />
                              </Grid>
                        </Grid>
                  )
            } else {
                  return null
            }
      }
}
export default withStyles(styles)(ResbuildmngBuildinglife)
